import { useCallback } from 'react'
import { useToast } from '../components'
import { SUPER_APP_CONFIG } from 'shared-ui/utils/constants'

export function useNativeShare() {
    const { showSuccess, showError } = useToast()

    const share = useCallback(async ({ title, text, url }) => {
        if (navigator.share) {
            try {
                await navigator.share({ title, text, url })
            } catch (err) {
                // user may cancel or error out
                console.error('Share failed:', err)
            }
        } else {
            // fallback: copy link or alert user
            try {
                await navigator.clipboard.writeText(url)
                showSuccess(SUPER_APP_CONFIG.SHARE_COPIED_SUCCESS)
            } catch {
                showError(SUPER_APP_CONFIG.SHARE_COPIED_FAIL)
            }
        }
    }, [showSuccess, showError])

    return share
}
